import React from "react";
import { addError, store } from "./Store";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import MessageCentre from './MessageCentre';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    store.dispatch(addError(`Error in react, ${error}: ${errorInfo}`))
  }

  render() {
    if (this.state.hasError) {
      let errors = store.getState().errors;

      return (
        <Container maxWidth="md">
          <Typography variant="subtitle1">
            Critical error occured in UI, refresh the page. Errors below.
          </Typography>
          <MessageCentre messages={errors}/>
        </Container>
      );
    }

    return this.props.children; 
  }
}
